import { OrderType } from '@vista-digital/ocapi-types/v1';
import { OrderDomainError, OrderDomainSpecificErrorCode } from '../errors/error';
export const isStandardOrder = (order) => {
    return !!order && order.type === OrderType.Standard;
};
export const isGiftShopOrder = (order) => {
    return !!order && order.type === OrderType.GiftShop;
};
export const isStandardOrGiftShopOrder = (order) => {
    return isStandardOrder(order) || isGiftShopOrder(order);
};
export const isSubscriptionOrder = (order) => {
    return !!order && order.type === OrderType.Subscription;
};
// Assertion Functions
export function assertIsOrderCreated(order, message) {
    if (!order) {
        throw new OrderDomainError(OrderDomainSpecificErrorCode.OrderNotCreated, `${message}. Order has not been created.`);
    }
}
export function assertIsOrderNotCreated(order, message) {
    if (order) {
        throw new OrderDomainError(OrderDomainSpecificErrorCode.OrderAlreadyCreated, `${message}. Order has already been created.`);
    }
}
export function assertIsStandardOrder(order, message) {
    assertOrderType(order, message, isStandardOrder);
}
export function assertIsGiftShopOrder(order, message) {
    assertOrderType(order, message, isGiftShopOrder);
}
export function assertIsStandardOrGiftShopOrder(order, message) {
    assertOrderType(order, message, isStandardOrGiftShopOrder);
}
export function assertIsSubscriptionOrder(order, message) {
    assertOrderType(order, message, isSubscriptionOrder);
}
const assertOrderType = (order, message, typeGuard) => {
    assertIsOrderCreated(order, message);
    if (!typeGuard(order)) {
        throw new OrderDomainError(OrderDomainSpecificErrorCode.InvalidOrderType, `${message}. Order type '${order.type}' is not supported.`);
    }
};
//# sourceMappingURL=order-type-utils.js.map